// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.field-qstring {
  border: 1px solid #ccc !important;
}

.legend-qstring {
  width: auto !important;
  font-size: 1.1rem !important;
}

.chips {
  border-radius: 10px;
  outline: none;
  cursor: pointer;
  margin-right: 9px;
  margin-left: -5px;
}

.btn-save {
  margin-top: 33px;
}

.chip-action {
  white-space: nowrap;
}

.cut-word {
  max-width: 100% !important;
}

.field-output {
  border: 1px solid #ccc !important;
  padding-left: 11px !important;
}

.field-qstring {
  border: 1px solid #ccc !important;
}

.legend-qstring {
  width: auto !important;
  font-size: 1.1rem !important;
}

.chips {
  border-radius: 10px;
  outline: none;
  cursor: pointer;
  margin-right: 9px;
  margin-left: -5px;
}

.btn-save {
  margin-top: 33px;
}

.chip-action {
  white-space: nowrap;
}

.cut-word {
  max-width: 100% !important;
}

.field-output {
  border: 1px solid #ccc !important;
  padding-left: 11px !important;
}

.pointer {
  cursor: pointer;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.item-active {
  border: 1px solid #008fc7 !important;
}

.check-icon {
  margin-right: 15px;
  color: #008fc7;
  animation: fadeIn ease-in-out 0.3s;
  -webkit-animation: fadeIn ease-in-out 0.3s;
  -moz-animation: fadeIn ease-in-out 0.3s;
  -o-animation: fadeIn ease-in-out 0.3s;
  -ms-animation: fadeIn ease-in-out 0.3s;
}

.path-container {
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.active-path {
  color: #008fc7;
}

.icon-container {
  width: 25%;
}



.example-headers-align .mat-expansion-panel-header-description {
  justify-content: flex-end;
  align-items: right;
}

.example-headers-align .mat-expansion-panel-header {
  background-color: #f3f3f7;
  height: 48px !important;
}

::ng-deep .mat-expansion-panel-header-title {
  color: rgb(0, 143, 199);
}

::ng-deep .mat-expansion-panel {
  box-shadow: 2px 2px 1px -1px rgba(0, 143, 199, 0.2) !important;
  border: 1px solid #ebedf2;
}


.kanban-board {
  width: 45% !important;
}
.drag-role {
  border-radius: 4px;
  font-weight: 500;
  box-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.05);
  background: #fff;
  padding: 10px;
  margin-bottom: 20px;
  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  margin: 2px;
}

.dragged-role {
  min-height: 100px;
}

.drag-over {
  border: #ff525b dashed 2px;
}

.drag-hint {
  border: #ffc100 dashed 2px;
}

.drag-target-border {
  border: #5ae500 dashed 2px;
  height: 100%;
}

display-none{
    display:none;
}


.mat-step-icon-theme {
  text-align: center;
  color: #008fc7;
  font-size: 3.7rem;
}

.mat-step-text-theme {
  text-align: center;
  color: #008fc7;
  font-size: 1.1rem;
  font-weight: 500;
}

/*.mat-stepper-theme{
    height:100px !important
}*/

  ::ng-deep .mat-stepper-theme .mat-step-header {
    height: 100px !important
  }

/* ---------------------------------------------------------------
   Data setup: the fields are grouped so the step reads as identity,
   endpoint and authorization instead of one long grid.
   --------------------------------------------------------------- */

.ds-section {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin: 0.5rem 0 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #ebedf2;
}

.ds-section:not(:first-child) {
  margin-top: 1.75rem;
}

.ds-section__title {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #008fc7;
}

.ds-section__hint {
  font-size: 0.8rem;
  color: #74788d;
}

.ds-toggle {
  padding-top: 0.45rem;
}

.ds-toggle__hint {
  display: block;
  margin-top: 0.35rem;
  font-size: 0.76rem;
  line-height: 1.5;
  color: #74788d;
}

/* ---------------------------------------------------------------
   Request log
   --------------------------------------------------------------- */

.ds-log {
  padding: 1.5rem 0.5rem 0;
}

.ds-log__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.25rem;
}

.ds-log__hint {
  font-size: 0.8rem;
  color: #74788d;
}

.ds-log__state {
  padding: 2.5rem 1rem;
  text-align: center;
  color: #74788d;
}

.ds-log__rows {
  border: 1px solid #ebedf2;
  border-radius: 4px;
}

.ds-log__row + .ds-log__row {
  border-top: 1px solid #ebedf2;
}

.ds-log__summary {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.7rem 0.9rem;
  border: 0;
  background: none;
  text-align: left;
  cursor: pointer;
}

.ds-log__summary:hover {
  background: #f7f9fb;
}

.ds-log__summary i {
  font-size: 0.7rem;
  color: #74788d;
}

.ds-log__date {
  font-family: "SFMono-Regular", Menlo, Consolas, "Liberation Mono", monospace;
  font-size: 0.8rem;
  color: #2b3445;
}

.ds-log__user {
  font-size: 0.8rem;
  color: #74788d;
}

.ds-log__detail {
  padding: 0 0.9rem 1rem 2.4rem;
}

.ds-log__block + .ds-log__block {
  margin-top: 0.9rem;
}

.ds-log__label {
  display: block;
  margin-bottom: 0.3rem;
  font-size: 0.66rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #74788d;
}

.ds-log__detail pre {
  max-height: 16rem;
  margin: 0;
  padding: 0.7rem 0.85rem;
  overflow: auto;
  border-radius: 3px;
  background: #f7f8fa;
  font-family: "SFMono-Regular", Menlo, Consolas, "Liberation Mono", monospace;
  font-size: 0.76rem;
  line-height: 1.6;
  color: #2b3445;
  white-space: pre-wrap;
  word-break: break-word;
}

.ds-log__pager {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 1rem;
}

.ds-log__page {
  font-size: 0.8rem;
  color: #74788d;
}

/* ---------------------------------------------------------------
   Chaining: this data source runs after another one and reads
   values out of its answer. The wires below are the whole point of
   the section, so they carry the weight; everything around them
   stays as quiet as the rest of the form.
   --------------------------------------------------------------- */

.ds-chain__fields {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  min-height: 2.4rem;
  padding: 0.45rem 0.55rem;
  border: 1px solid #ebedf2;
  border-radius: 4px;
  background: #f7f9fb;
}

.ds-chain__field {
  padding: 0.15rem 0.5rem;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ebedf2;
  font-family: "SFMono-Regular", Menlo, Consolas, "Liberation Mono", monospace;
  font-size: 0.76rem;
  color: #2b3445;
}

.ds-chain__state {
  font-size: 0.8rem;
  color: #74788d;
}

.ds-chain__state--warn {
  color: #d8552a;
}

.ds-chain__retry {
  padding: 0;
  border: 0;
  background: none;
  color: #008fc7;
  font-size: 0.8rem;
  text-decoration: underline;
  cursor: pointer;
}

.ds-chain__note {
  margin: 0.35rem 0 0;
  font-size: 0.8rem;
  line-height: 1.55;
  color: #74788d;
}

.ds-chain__inline-hint {
  display: block;
  margin-top: 0.3rem;
  font-size: 0.72rem;
  line-height: 1.45;
  color: #74788d;
}

/* The chain map itself. */

.ds-chain {
  margin: 0 0 1.5rem;
  padding: 1rem 1.1rem 1.1rem;
  border: 1px solid #ebedf2;
  border-left: 3px solid #008fc7;
  border-radius: 4px;
  background: #fff;
}

.ds-chain__head {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 0.6rem;
}

.ds-chain__eyebrow {
  font-size: 0.66rem;
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #008fc7;
}

.ds-chain__parent {
  font-size: 0.95rem;
  font-weight: 500;
  color: #2b3445;
}

.ds-chain__count {
  margin-left: auto;
  font-size: 0.76rem;
  color: #74788d;
}

.ds-chain__empty {
  margin: 0.75rem 0 0;
  font-size: 0.8rem;
  color: #74788d;
}

.ds-chain__wires {
  margin: 0.9rem 0 0;
  padding: 0;
  list-style: none;
}

.ds-chain__wire {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.45rem 0;
}

.ds-chain__wire + .ds-chain__wire {
  border-top: 1px solid #f2f3f7;
}

.ds-chain__from,
.ds-chain__to {
  font-family: "SFMono-Regular", Menlo, Consolas, "Liberation Mono", monospace;
  font-size: 0.8rem;
  color: #2b3445;
}

.ds-chain__from {
  min-width: 8rem;
  color: #74788d;
}

/* The connector: a hairline that ends in a small arrow head. */
.ds-chain__link {
  position: relative;
  flex: 0 0 3.25rem;
  height: 1px;
  background: #008fc7;
}

.ds-chain__link::after {
  content: "";
  position: absolute;
  top: -3px;
  right: 0;
  border-top: 3.5px solid transparent;
  border-bottom: 3.5px solid transparent;
  border-left: 5px solid #008fc7;
}

.ds-chain__area {
  padding: 0.1rem 0.45rem;
  border: 1px solid #ebedf2;
  border-radius: 10px;
  font-size: 0.68rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #74788d;
}

.ds-chain__wire--broken .ds-chain__link,
.ds-chain__wire--broken .ds-chain__link::after {
  background: #ffb822;
  border-left-color: #ffb822;
}

.ds-chain__flag {
  font-size: 0.72rem;
  color: #b7791f;
}

.ds-chain__warn {
  margin: 0.8rem 0 0;
  font-size: 0.78rem;
  color: #b7791f;
}

@media (max-width: 767.98px) {
  .ds-chain__from {
    min-width: 0;
  }

  .ds-chain__link {
    flex-basis: 1.75rem;
  }
}

/* The data source a row reads from, ahead of the field name on the wire. */
.ds-chain__api {
  min-width: 9rem;
  font-size: 0.76rem;
  font-weight: 500;
  color: #008fc7;
}

@media (max-width: 767.98px) {
  .ds-chain__api {
    min-width: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/views/data-source/AddEdit-data-sorce/AddEdit-data-sorce.component.css"],"names":[],"mappings":";;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAkDA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kCAAkC;EAClC,0CAA0C;EAC1C,uCAAuC;EACvC,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;;;AAIA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8DAA8D;EAC9D,yBAAyB;AAC3B;;;AAGA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mDAAmD;EACnD,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;IACI,YAAY;AAChB;;;AAGA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE;;EAEA;IACE;EACF;;AAEF;;;oEAGoE;;AAEpE;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;oEAEoE;;AAEpE;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,4EAA4E;EAC5E,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,4EAA4E;EAC5E,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;oEAKoE;;AAEpE;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,4EAA4E;EAC5E,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0BAA0B;;AAE1B;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,4EAA4E;EAC5E,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mCAAmC;EACnC,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,2EAA2E;AAC3E;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["\r\n\r\n.field-qstring {\r\n  border: 1px solid #ccc !important;\r\n}\r\n\r\n.legend-qstring {\r\n  width: auto !important;\r\n  font-size: 1.1rem !important;\r\n}\r\n\r\n.chips {\r\n  border-radius: 10px;\r\n  outline: none;\r\n  cursor: pointer;\r\n  margin-right: 9px;\r\n  margin-left: -5px;\r\n}\r\n\r\n.btn-save {\r\n  margin-top: 33px;\r\n}\r\n\r\n.chip-action {\r\n  white-space: nowrap;\r\n}\r\n\r\n.cut-word {\r\n  max-width: 100% !important;\r\n}\r\n\r\n.field-output {\r\n  border: 1px solid #ccc !important;\r\n  padding-left: 11px !important;\r\n}\r\n\r\n.field-qstring {\r\n  border: 1px solid #ccc !important;\r\n}\r\n\r\n.legend-qstring {\r\n  width: auto !important;\r\n  font-size: 1.1rem !important;\r\n}\r\n\r\n.chips {\r\n  border-radius: 10px;\r\n  outline: none;\r\n  cursor: pointer;\r\n  margin-right: 9px;\r\n  margin-left: -5px;\r\n}\r\n\r\n.btn-save {\r\n  margin-top: 33px;\r\n}\r\n\r\n.chip-action {\r\n  white-space: nowrap;\r\n}\r\n\r\n.cut-word {\r\n  max-width: 100% !important;\r\n}\r\n\r\n.field-output {\r\n  border: 1px solid #ccc !important;\r\n  padding-left: 11px !important;\r\n}\r\n\r\n.pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    opacity: 0.5;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@-moz-keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    opacity: 0.5;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    opacity: 0.5;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@-o-keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    opacity: 0.5;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@-ms-keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    opacity: 0.5;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.item-active {\r\n  border: 1px solid #008fc7 !important;\r\n}\r\n\r\n.check-icon {\r\n  margin-right: 15px;\r\n  color: #008fc7;\r\n  animation: fadeIn ease-in-out 0.3s;\r\n  -webkit-animation: fadeIn ease-in-out 0.3s;\r\n  -moz-animation: fadeIn ease-in-out 0.3s;\r\n  -o-animation: fadeIn ease-in-out 0.3s;\r\n  -ms-animation: fadeIn ease-in-out 0.3s;\r\n}\r\n\r\n.path-container {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n}\r\n\r\n.active-path {\r\n  color: #008fc7;\r\n}\r\n\r\n.icon-container {\r\n  width: 25%;\r\n}\r\n\r\n\r\n\r\n.example-headers-align .mat-expansion-panel-header-description {\r\n  justify-content: flex-end;\r\n  align-items: right;\r\n}\r\n\r\n.example-headers-align .mat-expansion-panel-header {\r\n  background-color: #f3f3f7;\r\n  height: 48px !important;\r\n}\r\n\r\n::ng-deep .mat-expansion-panel-header-title {\r\n  color: rgb(0, 143, 199);\r\n}\r\n\r\n::ng-deep .mat-expansion-panel {\r\n  box-shadow: 2px 2px 1px -1px rgba(0, 143, 199, 0.2) !important;\r\n  border: 1px solid #ebedf2;\r\n}\r\n\r\n\r\n.kanban-board {\r\n  width: 45% !important;\r\n}\r\n.drag-role {\r\n  border-radius: 4px;\r\n  font-weight: 500;\r\n  box-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.05);\r\n  background: #fff;\r\n  padding: 10px;\r\n  margin-bottom: 20px;\r\n  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);\r\n  margin: 2px;\r\n}\r\n\r\n.dragged-role {\r\n  min-height: 100px;\r\n}\r\n\r\n.drag-over {\r\n  border: #ff525b dashed 2px;\r\n}\r\n\r\n.drag-hint {\r\n  border: #ffc100 dashed 2px;\r\n}\r\n\r\n.drag-target-border {\r\n  border: #5ae500 dashed 2px;\r\n  height: 100%;\r\n}\r\n\r\ndisplay-none{\r\n    display:none;\r\n}\r\n\r\n\r\n.mat-step-icon-theme {\r\n  text-align: center;\r\n  color: #008fc7;\r\n  font-size: 3.7rem;\r\n}\r\n\r\n.mat-step-text-theme {\r\n  text-align: center;\r\n  color: #008fc7;\r\n  font-size: 1.1rem;\r\n  font-weight: 500;\r\n}\r\n\r\n/*.mat-stepper-theme{\r\n    height:100px !important\r\n}*/\r\n\r\n  ::ng-deep .mat-stepper-theme .mat-step-header {\r\n    height: 100px !important\r\n  }\r\n\n/* ---------------------------------------------------------------\n   Data setup: the fields are grouped so the step reads as identity,\n   endpoint and authorization instead of one long grid.\n   --------------------------------------------------------------- */\n\n.ds-section {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n  margin: 0.5rem 0 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #ebedf2;\n}\n\n.ds-section:not(:first-child) {\n  margin-top: 1.75rem;\n}\n\n.ds-section__title {\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  color: #008fc7;\n}\n\n.ds-section__hint {\n  font-size: 0.8rem;\n  color: #74788d;\n}\n\n.ds-toggle {\n  padding-top: 0.45rem;\n}\n\n.ds-toggle__hint {\n  display: block;\n  margin-top: 0.35rem;\n  font-size: 0.76rem;\n  line-height: 1.5;\n  color: #74788d;\n}\n\n/* ---------------------------------------------------------------\n   Request log\n   --------------------------------------------------------------- */\n\n.ds-log {\n  padding: 1.5rem 0.5rem 0;\n}\n\n.ds-log__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1.25rem;\n}\n\n.ds-log__hint {\n  font-size: 0.8rem;\n  color: #74788d;\n}\n\n.ds-log__state {\n  padding: 2.5rem 1rem;\n  text-align: center;\n  color: #74788d;\n}\n\n.ds-log__rows {\n  border: 1px solid #ebedf2;\n  border-radius: 4px;\n}\n\n.ds-log__row + .ds-log__row {\n  border-top: 1px solid #ebedf2;\n}\n\n.ds-log__summary {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0.7rem 0.9rem;\n  border: 0;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n}\n\n.ds-log__summary:hover {\n  background: #f7f9fb;\n}\n\n.ds-log__summary i {\n  font-size: 0.7rem;\n  color: #74788d;\n}\n\n.ds-log__date {\n  font-family: \"SFMono-Regular\", Menlo, Consolas, \"Liberation Mono\", monospace;\n  font-size: 0.8rem;\n  color: #2b3445;\n}\n\n.ds-log__user {\n  font-size: 0.8rem;\n  color: #74788d;\n}\n\n.ds-log__detail {\n  padding: 0 0.9rem 1rem 2.4rem;\n}\n\n.ds-log__block + .ds-log__block {\n  margin-top: 0.9rem;\n}\n\n.ds-log__label {\n  display: block;\n  margin-bottom: 0.3rem;\n  font-size: 0.66rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #74788d;\n}\n\n.ds-log__detail pre {\n  max-height: 16rem;\n  margin: 0;\n  padding: 0.7rem 0.85rem;\n  overflow: auto;\n  border-radius: 3px;\n  background: #f7f8fa;\n  font-family: \"SFMono-Regular\", Menlo, Consolas, \"Liberation Mono\", monospace;\n  font-size: 0.76rem;\n  line-height: 1.6;\n  color: #2b3445;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.ds-log__pager {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 1rem;\n}\n\n.ds-log__page {\n  font-size: 0.8rem;\n  color: #74788d;\n}\n\n/* ---------------------------------------------------------------\n   Chaining: this data source runs after another one and reads\n   values out of its answer. The wires below are the whole point of\n   the section, so they carry the weight; everything around them\n   stays as quiet as the rest of the form.\n   --------------------------------------------------------------- */\n\n.ds-chain__fields {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  min-height: 2.4rem;\n  padding: 0.45rem 0.55rem;\n  border: 1px solid #ebedf2;\n  border-radius: 4px;\n  background: #f7f9fb;\n}\n\n.ds-chain__field {\n  padding: 0.15rem 0.5rem;\n  border-radius: 3px;\n  background: #fff;\n  border: 1px solid #ebedf2;\n  font-family: \"SFMono-Regular\", Menlo, Consolas, \"Liberation Mono\", monospace;\n  font-size: 0.76rem;\n  color: #2b3445;\n}\n\n.ds-chain__state {\n  font-size: 0.8rem;\n  color: #74788d;\n}\n\n.ds-chain__state--warn {\n  color: #d8552a;\n}\n\n.ds-chain__retry {\n  padding: 0;\n  border: 0;\n  background: none;\n  color: #008fc7;\n  font-size: 0.8rem;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.ds-chain__note {\n  margin: 0.35rem 0 0;\n  font-size: 0.8rem;\n  line-height: 1.55;\n  color: #74788d;\n}\n\n.ds-chain__inline-hint {\n  display: block;\n  margin-top: 0.3rem;\n  font-size: 0.72rem;\n  line-height: 1.45;\n  color: #74788d;\n}\n\n/* The chain map itself. */\n\n.ds-chain {\n  margin: 0 0 1.5rem;\n  padding: 1rem 1.1rem 1.1rem;\n  border: 1px solid #ebedf2;\n  border-left: 3px solid #008fc7;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.ds-chain__head {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n}\n\n.ds-chain__eyebrow {\n  font-size: 0.66rem;\n  font-weight: 600;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  color: #008fc7;\n}\n\n.ds-chain__parent {\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: #2b3445;\n}\n\n.ds-chain__count {\n  margin-left: auto;\n  font-size: 0.76rem;\n  color: #74788d;\n}\n\n.ds-chain__empty {\n  margin: 0.75rem 0 0;\n  font-size: 0.8rem;\n  color: #74788d;\n}\n\n.ds-chain__wires {\n  margin: 0.9rem 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.ds-chain__wire {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  padding: 0.45rem 0;\n}\n\n.ds-chain__wire + .ds-chain__wire {\n  border-top: 1px solid #f2f3f7;\n}\n\n.ds-chain__from,\n.ds-chain__to {\n  font-family: \"SFMono-Regular\", Menlo, Consolas, \"Liberation Mono\", monospace;\n  font-size: 0.8rem;\n  color: #2b3445;\n}\n\n.ds-chain__from {\n  min-width: 8rem;\n  color: #74788d;\n}\n\n/* The connector: a hairline that ends in a small arrow head. */\n.ds-chain__link {\n  position: relative;\n  flex: 0 0 3.25rem;\n  height: 1px;\n  background: #008fc7;\n}\n\n.ds-chain__link::after {\n  content: \"\";\n  position: absolute;\n  top: -3px;\n  right: 0;\n  border-top: 3.5px solid transparent;\n  border-bottom: 3.5px solid transparent;\n  border-left: 5px solid #008fc7;\n}\n\n.ds-chain__area {\n  padding: 0.1rem 0.45rem;\n  border: 1px solid #ebedf2;\n  border-radius: 10px;\n  font-size: 0.68rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #74788d;\n}\n\n.ds-chain__wire--broken .ds-chain__link,\n.ds-chain__wire--broken .ds-chain__link::after {\n  background: #ffb822;\n  border-left-color: #ffb822;\n}\n\n.ds-chain__flag {\n  font-size: 0.72rem;\n  color: #b7791f;\n}\n\n.ds-chain__warn {\n  margin: 0.8rem 0 0;\n  font-size: 0.78rem;\n  color: #b7791f;\n}\n\n@media (max-width: 767.98px) {\n  .ds-chain__from {\n    min-width: 0;\n  }\n\n  .ds-chain__link {\n    flex-basis: 1.75rem;\n  }\n}\n\n/* The data source a row reads from, ahead of the field name on the wire. */\n.ds-chain__api {\n  min-width: 9rem;\n  font-size: 0.76rem;\n  font-weight: 500;\n  color: #008fc7;\n}\n\n@media (max-width: 767.98px) {\n  .ds-chain__api {\n    min-width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
